import React from 'react';
import { ArrowRight, Shield, Lock, Clock } from 'lucide-react';

interface FinalCtaProps {
  onCheckout: () => void;
  isLoading: boolean;
}

export function FinalCta({ onCheckout, isLoading }: FinalCtaProps) {
  return (
    <section className="py-20 sm:py-28 bg-gray-900 bg-dot-pattern relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-gray-900 via-gray-900/95 to-gray-900" />
      <div className="relative z-10 max-w-3xl mx-auto px-4 sm:px-6 text-center">
        <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
          Get Your Agreement Reviewed Now
        </h2>
        <p className="text-lg text-gray-400 mb-10 max-w-xl mx-auto leading-relaxed">
          Full Renters Rights Bill compliance check. Rewritten draft included. Results in minutes.
        </p>

        <button
          onClick={onCheckout}
          disabled={isLoading}
          className="group relative inline-flex items-center gap-3 bg-white text-gray-900 px-10 py-5 rounded-2xl font-semibold text-lg hover:bg-gray-100 transition-all duration-300 shadow-lg hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed mb-8"
        >
          {isLoading ? (
            <>
              <svg className="animate-spin w-5 h-5" viewBox="0 0 24 24" fill="none">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
              </svg>
              Redirecting to payment...
            </>
          ) : (
            <>
              Review My Agreement &mdash; &pound;15.50
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </>
          )}
        </button>

        <div className="flex flex-wrap items-center justify-center gap-6 text-gray-500">
          <div className="flex items-center gap-2">
            <Lock className="w-4 h-4" />
            <span className="text-sm">256-bit SSL</span>
          </div>
          <div className="flex items-center gap-2">
            <Shield className="w-4 h-4" />
            <span className="text-sm">PCI DSS Compliant</span>
          </div>
          <div className="flex items-center gap-2">
            <Clock className="w-4 h-4" />
            <span className="text-sm">Instant Delivery</span>
          </div>
        </div>
      </div>
    </section>
  );
}
